import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-logo-section">
            <img
              src="./assets/Logo.webp"
              alt="RemeCure Scar Logo"
              className="logo"
            />
          </div>

          <nav className="footer-nav">
            <ul>
              <li>
                <a href="/" className="active">
                  Home
                </a>
              </li>
              <li>
                <a href="/products">Remecure Scar products</a>
              </li>
              <li>
                <a href="/where-to-buy">Where to Buy</a>
              </li>
              <li>
                <a href="/articles">Articles</a>
              </li>
              <li>
                <a href="/contact">Contact Us</a>
              </li>
              <li>
                <a href="/terms">Terms & Conditions</a>
              </li>
              <li>
                <a href="/privacy">Privacy Policy</a>
              </li>
              <li>
                <a href="/patient-info">Patient Information</a>
              </li>
            </ul>
          </nav>

          <div className="footer-aspen">
            <img
              src="./assets/footer-logo.webp"
              alt="Aspen Healthcare Logo"
              className="aspen-logo"
            />
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            Aspen Healthcare FZ LLC. Trademarks are owned by or licensed to the
            Aspen group of companies.
          </p>
          <p>
            Copyright © 2025. Aspen group of companies or its licensor. All
            rights reserved.
          </p>
          <p className="disclaimer">
            Always read the label. This website intended for residents in the
            UAE and KSA. MENA-SID-03-25-00001, April 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
